import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AddDataFine } from 'src/app/shared/model/documentation.model';
import { DocumentKey } from 'src/app/shared/model/request-detail.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DataEntryService {
  url =
    environment.env === 'dev'
      ? 'https://' +
        `${environment.API_CONTEXT}/data-entry-service/v1/employee-leasing`
      : `${environment.API_CONTEXT}/data-entry-service/v1/employee-leasing`;
  urlPublic =
    environment.env === 'dev'
      ? 'https://' +
        `${environment.API_CONTEXT}/data-entry-service/v1/docs/public`
      : `${environment.API_CONTEXT}/data-entry-service/v1/docs/public`;
  urlCampaigns =
    environment.env === 'dev'
      ? 'https://' + `${environment.API_CONTEXT}/data-entry-service/v1`
      : `${environment.API_CONTEXT}/data-entry-service/v1`;

  constructor(private http: HttpClient) {}

  downloadDocument(id: DocumentKey) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      responseType: 'blob',
      Accept: 'application/octet-stream',
      observe: 'response'
    });
    return this.http.post(`${this.url}/docs/d`, id, {
      headers,
      responseType: 'blob' as 'json'
    });
  }

  sendInfo(addDataFine: AddDataFine) {
    const bodyParams = addDataFine;
    return this.http.post(`${this.url}/docs/info`, bodyParams);
  }

  //Public documentation
  getPublicDocumentation(group: string) {
    return this.http.get<string[]>(`${this.urlPublic}?group=${group}`);
  }

  viewPublicDocument(filename: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      responseType: 'blob',
      Accept: 'application/octet-stream',
      observe: 'response'
    });
    return this.http.post(`${this.urlPublic}`, filename, {
      headers,
      responseType: 'blob' as 'arraybuffer'
    });
  }

  deleteUploadedDocument(id: string) {
    return this.http.delete(`${this.url}/files/${id}`);
  }
}
